import request from '@/common/utils/request';
// 注册
export function registerUser(data) {
    return request({
        url: 'user/register',
        method: 'post',
        data: data
    })
}
// 密码登录
export function accountLogin(data) {
    return request({
        url: 'user/login',
        method: 'post',
        data: data
    })
}
// 验证码登录
export function postCodeAjax(data){
    return request({
        url:'user/mobilelogin',
        method:'post',
        data:data
    })
}
// 获取图形验证码
export function getCodeAjax(data){
    return request({
        url:'user/getcode',
        method:'get',
        params:data
    })
}
// 获取验证码
export function provingAjax(data) {
    return request({
        url: 'sms/send',
        method: 'post',
        data: data
    })
}
export function forgetPassword(data){
    return request({
        url:'user/resetpwd',
        method:'post',
        data:data
    })
}
// 获取首页轮播图
export function getBannerAjax(data){
    return request({
        url:'index/banner',
        method:'get',
        params:data
    })
}
// 获取首页数据统计
export function getTotlaAjax(data){
    return request({
        url:'index/settings',
        method:'get',
        data:data
    })
}
// 获取首页金融产品
export function getNavigationAjax(data){
    return request({
        url:'index/navigation',
        method:'get',
        data:data
    })
}
// 获取首页合作伙伴
export function getPartnerAjax(data){
    return request({
        url:'index/partner',
        method:'get',
        data:data
    })
}
// 获取服务列表部分
export function getServiceListAjax(data){
    return request({
        url:'index/morelist2',
        method:'get',
        params:data
    })
}
// 获取服务详情
export function getDetailAjax(data){
    return request({
        url:'index/detail',
        method:'get',
        params:data
    })
}
// 获取订单列表
export function getOrderListAjax(data){
    return request({
        url:'order/list',
        method:'get',
        params:data
    })
}
// 金融分类
export function getCategorizeAjax(data){
    return request({
        url:'index/categorize',
        method:'get',
        data:data
    })
}
// 立即申请
export function applyAjax(data) {
    return request({
        url:'order/add',
        method:'post',
        data: data
    })
}
// 获取关于我们信息接口
export function getNewsInfoAjax(data) {
    return request({
        url:'index/about',
        method:'get',
        data: data
    })
}
export function getContactInfoAjax(data) {
    return request({
        url:'index/contact',
        method:'get',
        data: data
    })
}




